module.exports = __webpack_public_path__ + "a1326fda4204c8818ff353410e69c212.png";